<template>
  <div class="product_box cart_product_box flex-r-c-c">
    <div class="pro_info flex-r-s-c">
      <van-image width="2.13rem" height="2.13rem" :src="myinfo.iconUrl" />
      <div class="cart_pro_info">
        <div class="pro_name van-multi-ellipsis--l2" style="width: 6.5rem;">{{ myinfo.proName }}</div>
        <div class="pro_brand_model van-ellipsis" style="width: 6.5rem;">{{ myinfo.brand }} | {{ myinfo.specifications }}</div>
        <!-- <div class="pro_tags">1</div> -->
        <div class="pro_bottom flex-r-sb-c" style="width: 6.5rem;">
          <div class="pro_money">￥<span
            style="font-size: 0.49rem;"
          >{{ myinfo.price || myinfo.refundPrice }}</span></div>
          <div class="pro_num_change_no" style="font-size: 0.39rem;">x {{ myinfo.priceNum || myinfo.refundNum }}</div>
          <div class="pro_num_change_no" style="font-size: 0.39rem;"> {{ myinfo.priceTotal || myinfo.refundTotal }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: { type: Object, default: () => { } }
  },
  data() {
    return {
      myinfo: this.info
    }
  },
  methods: {
    // 修改数量
    changeNum(val) {
      if (val > parseInt(this.myinfo.refundNum)) {
        val = parseInt(this.myinfo.remain)
        this.$toast({ message: '请重新填写数量！', duration: 1 * 1000 })
        this.$emit('changeNum', val)
      } else {
        this.$emit('changeNum', val)
      }
    }
  }
}
</script>
